import createElement from '../logical-components/createElement';
import svgs from './svgs';
import './scss/pagination.scss';
var pagination = function (_a) {
    var meta = _a.meta, changePage = _a.changePage;
    var element = createElement('div');
    element.className = '_msnlq-pagination-wrapper';
    if (!(meta === null || meta === void 0 ? void 0 : meta.current_page) || (meta === null || meta === void 0 ? void 0 : meta.last_page) === 1) {
        return element;
    }
    var currentPage = meta === null || meta === void 0 ? void 0 : meta.current_page;
    element.innerHTML = "<div class='_msnlq-pg-w'>\n        <div class='_msnlq-pg-pp-b _msnlq-pg-b'>\n            <div class='_msnlq-pg-fp-p-w _msnlq-flipped'>\n                <span class='_msnlq-pg-a-c-a'> ".concat(svgs.arrow, " </span>\n                <span class='_msnlq-pg-a-c-b'> ").concat(svgs.arrow, " </span>\n            </div>\n        </div>\n        <div class='_msnlq-pg-slctrs-b _msnlq-pg-pb'>\n            <input value='").concat(currentPage, "'> <span> / </span> <span class='_msnlq-pg-ma-pa'> ").concat(meta === null || meta === void 0 ? void 0 : meta.last_page, " </span>\n        </div>\n        <div class='_msnlq-pg-np-b _msnlq-pg-b'>\n            <div class='_msnlq-pg-fp-p-w '>\n                <span class='_msnlq-pg-a-c-a'> ").concat(svgs.arrow, " </span>\n                <span class='_msnlq-pg-a-c-b'> ").concat(svgs.arrow, " </span>\n            </div>\n        </div>\n    </div>");
    // Input field
    var input = element.querySelector('input');
    var inputTimeout = null;
    input.addEventListener('input', function (event) {
        clearTimeout(inputTimeout);
        var target = event.target;
        var value = parseInt(target.value);
        var validation = value && value >= 1 && value <= meta.last_page;
        if (validation) {
            inputTimeout = setTimeout(function () {
                changePage(value);
            }, 250);
        }
        else {
            value = currentPage;
            input.value = "".concat(value);
        }
    });
    var handleAction = function (direction) {
        var page = Math.min(meta.last_page, Math.max(1, currentPage + direction));
        if (page !== currentPage) {
            currentPage = page;
            changePage(page, function () {
                var input = element.querySelector('input');
                input.value = "".concat(page);
            });
        }
    };
    // Buttons
    element.querySelector('._msnlq-pg-pp-b').addEventListener('click', function () {
        handleAction(-1);
    });
    element.querySelector('._msnlq-pg-np-b').addEventListener('click', function () {
        handleAction(+1);
    });
    return element;
};
export default pagination;
